import { render, staticRenderFns } from "./BasicPriceManage.vue?vue&type=template&id=48815054&"
import script from "./BasicPriceManage.vue?vue&type=script&lang=js&"
export * from "./BasicPriceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports